import { render, staticRenderFns } from "./regulationsControl.vue.js?vue&type=template&id=2e046ee8!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./regulationsControl.vue?vue&type=template&id=2e046ee8"
import script from "./regulationsControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./regulationsControl.vue?vue&type=script&lang=js"
export * from "./regulationsControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./regulationsControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports